import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { map } from 'rxjs';

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  const token = state.root.queryParamMap.get('token');
  if(token){
    authService.setUsuario(token);
    sessionStorage.setItem(authService.ACCESS_TOKEN_KEY, token);
    authService.initializeSession(token)
    const params = { ...state.root.params };
    delete params['token'];
    router.navigate(['/manutencao-projetos'], { queryParams: params });
  }
 
  if (authService.isAuthenticated())
    return true;
  return router.createUrlTree(['/login'])
}
